import React from 'react';
import ReactDOM from 'react-dom';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action, observable, computed } from 'mobx';
import moment from 'moment';

import { Tabs } from '../component/Tabs';
import { Dropdown } from '../component/Dropdown';
import { DayPickerYMD } from '../component/DayPicker';
import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';

import { BWStepBar } from '../component/BWStepBar';
import { BWReceipt } from '../component/BWReceipt';
import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime } from '../../model/formatters';

import translateBase from '../../translate';

let translate = translateBase.bindPage('bw04PersonalData');

class TypeaheadSelector {

  @observable typedValue;

  @action.bound handleNewSelection() {
    this.typedValue = undefined;
  }

  @action.bound handleChange(event) {
    this.typedValue = event.target.value;
  }

  filtered = (options) => {
    if (!this.typedValue) {
      return options;
    } else {
      return options.filter(opt => {
        return (opt.text || '').toLowerCase().indexOf(this.typedValue.toLowerCase()) > -1;
      })
    }
  }

  textValue = (currentTextValue) => {
    if (this.typedValue === undefined) {
      return currentTextValue
    } else {
      return this.typedValue;
    }
  }
}

@observer
class CountryField extends React.Component {
  countryTypeaheadSelector = new TypeaheadSelector();

  @action.bound handleInputClick(event) {
    event.persist();
    if (!this.props.readOnly) {
      this.elmDropdown.handleOpenerClick(event);
      setTimeout(() => {
        event.target.focus();
        event.target.select();
      }, 10)
    }
  }

  @action.bound handleInputChange(event) {
    if (!this.props.readOnly) {
      this.countryTypeaheadSelector.handleChange(event);
      this.elmDropdown.handleOpenerClick(event);
    }
  }

  @action.bound handleInputFocus(event) {
    if (!this.props.readOnly) {
      this.elmDropdown.handleOpenerClick(event);
    }
  }

  @action.bound handleInputBlur(event) {
    if (!this.props.readOnly) {
      this.elmDropdown.handleClose(event);
    }
  }

  @action.bound handleCountryClick(event, country) {
    if (!this.props.readOnly) {
      this.props.form.dirtyValues.country = country.value;
      this.elmDropdown.handleClose(event);
      this.countryTypeaheadSelector.handleNewSelection();
    }
  }

  @action.bound refDropdown(elm) {
    this.elmDropdown = elm;
  }

  render() {
    return (
      <Dropdown ref={this.refDropdown}
        onClose={() => this.props.form.setVisited('country')}>{({ ref, isOpen, onOpen, onClose, onOpenOnly }) => <Observer>{() =>
          <div className={"row" + (!isValid(this.props.form, 'country') ? " error" : "")} ref={ref}>
            <div className="label">
              {translate("country", "Land *")}
            </div>
            <Validations form={this.props.form} fieldName="country" />
            <div className="input">
              <input type="text"
                value={this.countryTypeaheadSelector.textValue(this.props.textValue)}
                onMouseDown={this.handleInputClick}
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
                onBlur={this.handleInputBlur}
                readOnly={this.props.readOnly}
              />
            </div>
            {!this.props.readOnly && <div className={"dropdown" + (isOpen ? "" : " hidden")}>
              <ul>
                {this.countryTypeaheadSelector.filtered(this.props.options).map(country =>
                  <li><a onMouseDown={(event) => this.handleCountryClick(event, country)}>
                    {country.text}
                  </a></li>
                )}
              </ul>
            </div>}
          </div>
        }</Observer>}</Dropdown>
    )
  }
}

function ffProps(form, fieldName) {
  return {
    value: form.values[fieldName],
    onChange: event => form.dirtyValues[fieldName] = event.target.value,
    readOnly: form.readOnlyAll,
    onBlur: () => { form.setVisited(fieldName); },
  }
}

function isValid(form, fieldName) {
  return !form.validations[fieldName] || form.validations[fieldName].length === 0;
}

@observer
class AddrBlock extends React.Component {
  render() {
    const { tab, masterData, personalDataForm, vPersonalData } = this.props;
    return (
      <div className="tab-content_page" id={tab.tabId} key={tab.tabId}>
        <div className={"row" + (!isValid(tab.form, 'street') ? " error" : "")}>
          <div className="label">
            {translate("street", "Strasse, Nr. *")}
          </div>
          <Validations form={tab.form} fieldName="street" />
          <div className="input">
            <input type="text"
              value={tab.form.values.street}
              onChange={event => tab.form.dirtyValues.street = event.target.value}
              readOnly={tab.form.readOnlyAll}
              onBlur={() => tab.form.setVisited('street')} />
          </div>
        </div>
        <div className={"row" + (!isValid(tab.form, 'addition') ? " error" : "")}>
          <div className="label">
            {translate("addressAddition", "Adresszusatz")}
          </div>
          <Validations form={tab.form} fieldName="addition" />
          <div className="input">
            <input type="text" value={tab.form.values.addition}
              onChange={event => tab.form.dirtyValues.addition = event.target.value}
              readOnly={tab.form.readOnlyAll}
              onBlur={() => tab.form.setVisited('addition')} />
          </div>
        </div>
        <div className={"row" + (!isValid(tab.form, 'postalCode') ? " error" : "")}>
          <div className="label">
            {translate("postNumber", "PLZ *")}
          </div>
          <Validations form={tab.form} fieldName="postalCode" />
          <div className="input">
            <input type="text" value={tab.form.values.postalCode}
              onChange={event => tab.form.dirtyValues.postalCode = event.target.value}
              readOnly={tab.form.readOnlyAll}
              onBlur={() => tab.form.setVisited('postalCode')} />
          </div>
        </div>
        <div className={"row" + (!isValid(tab.form, 'city') ? " error" : "")}>
          <div className="label">
            {translate("place", "Ort *")}
          </div>
          <Validations form={tab.form} fieldName="city" />
          <div className="input">
            <input type="text" value={tab.form.values.city}
              onChange={event => tab.form.dirtyValues.city = event.target.value}
              readOnly={tab.form.readOnlyAll}
              onBlur={() => tab.form.setVisited('city')} />
          </div>
        </div>
        <CountryField
          textValue={masterData.countryTextByValue(tab.form.values.country)}
          readOnly={tab.form.readOnlyAll}
          form={tab.form}
          options={masterData.optCountries}
        />
      </div>
    )
  }
}

@observer
class Validations extends React.Component {
  render() {
    const { form, fieldName } = this.props;
    return (!isValid(form, fieldName) ?
      <div className="validations">
        <ul>
          {form.validations[fieldName] && form.validations[fieldName].length > 0 &&
            <li>{form.validations[fieldName][0]}</li>
          }
        </ul>
      </div>
      :
      null
    )
  }
}

@inject(stores => ({
  flasher: stores.app.flasher,
  navigation: stores.app.navigation,
  masterData: stores.app.masterData,
  vPersonalData: stores.app.vPersonalData,
  vUserRegistration: stores.app.vUserRegistration,
  rentalTransaction: stores.app.rentalTransaction,
  bestOffers: stores.app.bestOffers,
  personalDataForm: stores.app.personalDataForm,
  personalAddressForms: stores.app.personalAddressForms,
  loginForm: stores.app.loginForm,
  authentication: stores.app.authentication,
  vBookingWizard: stores.app.vBookingWizard,
  businessUnit: stores.app.businessUnit
}))
@observer
export class BWPersonalData extends React.Component {

  constructor() {
    super();
    this.state = {
      iFrameError: false
    }
  }

  getPrevActionLink() {
    const { navigation } = this.props;
    switch (this.props.vBookingWizard.prevPersonalDataAction) {
      case "Services":
        return <a className="back" onClick={navigation.goBWServices}><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
      case "Accessories":
        return <a className="back" onClick={navigation.goBWAccessories}><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
      case "OfferDetails":
        return <a className="back" onClick={navigation.goBWOfferDetails}><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
    }
  }

  componentDidMount() {
    this.scrollToLoginForm();
  }

  componentDidUpdate() {
    this.scrollToLoginForm();
  }

  scrollToLoginForm() {
    var element = document.getElementById("bw-login-container");
    if (element) {
      var elementTitle = document.getElementById("personalDataTitle");
      if (elementTitle) {
        elementTitle.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }
    }
  }

  onLoadIframe = () => {
    var iFrame = document.getElementById("login-iframe");
    if (iFrame) {
      var hasError = iFrame.contentWindow.document.querySelector(".alert-danger") != null;
      this.setState({
        iFrameError: hasError
      });
    }
  }

  render() {
    const { flasher, navigation, rentalTransaction, bestOffers, personalDataForm,
      personalAddressForms, loginForm, authentication, masterData, vPersonalData,
      vUserRegistration, businessUnit } = this.props;
    const tabDef = [
      { tabId: 'tab-1', form: personalAddressForms[0] },
      { tabId: 'tab-2', form: personalAddressForms[1] },
      { tabId: 'tab-3', form: personalAddressForms[2] },
    ];

    vPersonalData.usingPostAsBilling; // !Important to keep - needed somewhere outside Tabs to update them when changed.

    return (
      <div>
        <SiteHeader />

        <BWStepBar activeStep={4} />

        <BWReceipt />


        <section className="wizard-container booking-view">
          <div className="wrapper">

            <div className="row wizard-content">
              <div className="column-12">
                <h3 className="mali-blue" id="personalDataTitle">{translate("personalData", "Personalien")}</h3>

                {(!authentication.loggedIn && !vPersonalData.showGuestLogin) &&
                  <div className={"login-container" + (this.state.iFrameError ? " iframe-error" : "")} id="bw-login-container">
                    {businessUnit.loginMessage && <div className="row loginMessage">
                      <h5>{businessUnit.loginMessage}</h5>
                    </div>}
                    <div className="login-iframe-holder">
                      <iframe src="/auth" height="100%" width="100%" frameBorder="0" scrolling="no" id="login-iframe" onLoad={this.onLoadIframe}></iframe>
                    </div>
                    <div className="row">
                      {vPersonalData.isGuestAllowed &&
                        <a className="guest small" onClick={() => vPersonalData.showGuestLogin = true}>{translate("loginAsGuest", "Als Gast buchen")} <i className="fa fa-user" aria-hidden="true"></i></a>
                      }
                    </div>
                  </div>}

                {(vPersonalData.showGuestLogin || authentication.loggedIn) && <div className="loggedin-container">
                  <div className="column-6">
                    <div className="row">
                      <h4>{translate("customerInformation", "Kundeninformation")}</h4>
                    </div>
                    <Dropdown onClose={() => personalDataForm.setVisited('salutation')}>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
                      <div className={"row" + (!isValid(personalDataForm, 'salutation') ? " error" : "")} ref={ref}>
                        <div className="label">
                          {translate("salutation", "Anrede *")}
                        </div>
                        <Validations form={personalDataForm} fieldName="salutation" />
                        <div className="input" onClick={onOpen}>
                          <input type="text" value={masterData.salutationTextByValue(personalDataForm.values.salutation)}
                            readOnly={personalDataForm.readOnlyAll} />
                        </div>
                        {!personalDataForm.readOnlyAll && <div className={"dropdown" + (isOpen ? "" : " hidden")}>
                          <ul>
                            {masterData.optSalutations.map(salutation =>
                              <li><a onClick={() => { personalDataForm.dirtyValues.salutation = salutation.value; onClose() }}>
                                {salutation.text}
                              </a></li>
                            )}

                          </ul>
                        </div>}
                      </div>
                    }</Observer>}</Dropdown>
                    <div className={"row" + (!isValid(personalDataForm, 'firstName') ? " error" : "")}>
                      <div className="label">
                        {translate("firstName", "Vorname *")}
                      </div>
                      <Validations form={personalDataForm} fieldName="firstName" />
                      <div className="input">
                        <input type="text" value={personalDataForm.values.firstName}
                          onChange={event => personalDataForm.dirtyValues.firstName = event.target.value}
                          readOnly={personalDataForm.readOnlyAll}
                          onBlur={() => personalDataForm.setVisited('firstName')} />
                      </div>
                    </div>
                    <div className={"row" + (!isValid(personalDataForm, 'lastName') ? " error" : "")}>
                      <div className="label">
                        {translate("lastName", "Nachname *")}
                      </div>
                      <Validations form={personalDataForm} fieldName="lastName" />
                      <div className="input">
                        <input type="text" value={personalDataForm.values.lastName}
                          onChange={event => personalDataForm.dirtyValues.lastName = event.target.value}
                          readOnly={personalDataForm.readOnlyAll}
                          onBlur={() => personalDataForm.setVisited('lastName')} />
                      </div>
                    </div>
                    <div className={"row" + (!isValid(personalDataForm, 'organization') ? " error" : "")}>
                      <div className="label">
                        {translate("organization", "Organization")}
                      </div>
                      <Validations form={personalDataForm} fieldName="organization" />
                      <div className="input">
                        <input type="text" value={personalDataForm.values.organization}
                          onChange={event => personalDataForm.dirtyValues.organization = event.target.value}
                          readOnly={personalDataForm.readOnlyAll}
                          onBlur={() => personalDataForm.setVisited('organization')} />
                      </div>
                    </div>
                    <div className={"row" + (!isValid(personalDataForm, 'email') ? " error" : "")}>
                      <div className="label">
                        {translate("email", "E-Mail *")}
                      </div>
                      <Validations form={personalDataForm} fieldName="email" />
                      <div className="input">
                        <input type="email" value={personalDataForm.values.email}
                          onChange={event => personalDataForm.dirtyValues.email = event.target.value}
                          readOnly={personalDataForm.readOnlyAll}
                          onBlur={() => personalDataForm.setVisited('email')} />
                      </div>
                    </div>
                    <div className={"row" + (!isValid(personalDataForm, 'phone') ? " error" : "")}>
                      <div className="label">
                        {translate("phone", "Telefon")}
                      </div>
                      <Validations form={personalDataForm} fieldName="phone" />
                      <div className="input">
                        <input type="tel" value={personalDataForm.values.phone}
                          onChange={event => personalDataForm.dirtyValues.phone = event.target.value}
                          readOnly={personalDataForm.readOnlyAll}
                          onBlur={() => personalDataForm.setVisited('phone')} />
                      </div>
                    </div>
                    <div className={"row" + (!isValid(personalDataForm, 'mobilePhone') ? " error" : "")}>
                      <div className="label">
                        {translate("mobilePhone", "Mobiltelefon")}
                      </div>
                      <Validations form={personalDataForm} fieldName="mobilePhone" />
                      <div className="input">
                        <input type="tel" value={personalDataForm.values.mobilePhone}
                          onChange={event => personalDataForm.dirtyValues.mobilePhone = event.target.value}
                          readOnly={personalDataForm.readOnlyAll}
                          onBlur={() => personalDataForm.setVisited('mobilePhone')} />
                      </div>
                    </div>
                  </div>
                  <div className="column-6">
                    <div className="row address-title">
                      <h4>{translate("address", "Adresse")}</h4>
                    </div>
                    <div className="row">
                      <div className="post-address-container">
                        <AddrBlock tab={tabDef[0]} masterData={masterData} personalDataForm={personalDataForm} vPersonalData={vPersonalData} />
                        <div className="use-same-address">
                          <input type="checkbox"
                            checked={!vPersonalData.usingPostAsBilling}
                            onClick={vPersonalData.usePostAsBilling}
                          /> {translate("useDifferentBillingAddress", "Use different address for billing.")}
                        </div>
                      </div>
                      <div className="billing-address-container">
                        {!vPersonalData.usingPostAsBilling && <AddrBlock tab={tabDef[1]} masterData={masterData} personalDataForm={personalDataForm} vPersonalData={vPersonalData} />}
                      </div>
                    </div>
                  </div>
                </div>}

              </div>
            </div>

            <div className="row main-wizardbtns-container">
              <div className="column-6">
                {vPersonalData.showGuestLogin ?
                  <a className="back" onClick={() => vPersonalData.showGuestLogin = false}><i className="fa fa-times" aria-hidden="true"></i> {translate("cancelGuestLogin", "Gastbuchung Abbrechen")}</a>
                  :
                  this.getPrevActionLink()
                }

              </div>
              <div className="column-6">
                {(vPersonalData.showGuestLogin || authentication.loggedIn) &&
                  <a id="btn-fwd-bwpersonal" className="forward" onClick={vPersonalData.submit}>{translate("next", "Weiter")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                }
              </div>
            </div>

          </div>
        </section>

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/BWPersonalData.js